import React, { useEffect, useState } from "react";
import { Fab, Zoom } from "@mui/material";
import ArrowUpwardSharpIcon from "@mui/icons-material/ArrowUpwardSharp";

const GlobalScrollCard = () => {
  const [visible, setVisible] = useState(false);

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    setVisible(scrollTop > 300);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Zoom in={visible}>
      <Fab
        color="primary"
        size="medium"
        onClick={scrollToTop}
        aria-label="scroll back to top"
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 1000,
          boxShadow: 3,
          background: "linear-gradient(93.14deg, #1E90FF, #63B8FF)",
        }}
      >
        <ArrowUpwardSharpIcon
          sx={{
            animation: visible ? "bounce 1s infinite" : "none",
            width: 30,
            height: 30,
          }}
        />
      </Fab>
    </Zoom>
  );
};

export default GlobalScrollCard;
